import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDotSlash } from "@fortawesome/sharp-light-svg-icons";

export const UnsupportedMapOverlay = () => {
    return (
        <div
            className="w-full h-full flex items-center justify-center p-8"
            style={{
                backgroundColor: "#f9fafb",
                backgroundImage:
                    "repeating-linear-gradient(45deg, rgba(0, 0, 0, 0.03) 0, rgba(0, 0, 0, 0.03) 1px, transparent 1px, transparent 12px)",
            }}
        >
            <div className="flex flex-col items-center gap-6 max-w-md text-center">
                <FontAwesomeIcon
                    icon={faLocationDotSlash}
                    className="w-12 h-12 text-gray-400"
                />
                <div className="flex flex-col gap-2">
                    <h2 className="text-lg font-semibold text-gray-800">
                        Unable to display the map
                    </h2>
                    <p className="text-sm text-gray-600">
                        This map requires that hardware acceleration is enabled
                        in your browser. Try enabling graphics acceleration in
                        your browser settings, updating your graphics drivers,
                        or switching to a supported browser.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default UnsupportedMapOverlay;
